import EffectiveCaching from "./utils/cache";
const caching = new EffectiveCaching();
const serviceWorker = self;
self.addEventListener("install", (event) => {
    const installEvent = event;
    installEvent.waitUntil(caching.install().then(() => serviceWorker.skipWaiting()));
});
self.addEventListener("activate", (event) => {
    const activateEvent = event;
    activateEvent.waitUntil(caching.cleanup().then(() => serviceWorker.clients.claim()));
});
self.addEventListener("fetch", (event) => {
    const fetchEvent = event;
    const { request } = fetchEvent;
    if (request.method !== "GET") {
        return;
    }
    const url = new URL(request.url);
    if (url.origin !== self.location.origin) {
        return;
    }
    fetchEvent.respondWith(caching.handleRequest(request));
});
